// media name enum
export enum MEDIA_NAME {
  VIDEOS = 'videos',
  PHOTOS = 'photos',
  AUDIO = 'audio',
}
